import { AppHeaderBackButton } from '@ace-clublabs/shared-component-library';
import { AppFlow } from '@lib/web-shared';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useGlobalState } from '../shared/state';
import { PaymentAmount } from '@ace-clublabs/payments-component-library';

type Props = {
  minimumDue: number;
  fullBalance: number;
  onSubmit: (value: number) => void;
  appFlow: AppFlow;
  isMobileApp: boolean;
};

const PaymentAmountSelectionForm: React.FC<Props> = ({ minimumDue, fullBalance, onSubmit, appFlow, isMobileApp }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  const [amountChosen] = useGlobalState('amountChosen');

  const header =
    appFlow === AppFlow.AUTOPAY
      ? `To enroll in Auto Pay, you'll first need to pay the minimum amount due on your account`
      : `Let's review your payment`;

  const paymentAmountProps = {
    amountChosen,
    amountDue: minimumDue,
    balanceDue: fullBalance,
    header,
    onSubmit: onSubmit,
  };
  return (
    <div id="payment-amount-selection-form">
      {!isMobileApp && <AppHeaderBackButton id="back-button" onClick={handleBack} />}
      <PaymentAmount {...paymentAmountProps}></PaymentAmount>
    </div>
  );
};

export default PaymentAmountSelectionForm;
